// import * as React from 'react';
import React, { useRef, useState } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import moment from 'moment';
import { Row, Col, Container } from 'react-bootstrap';
import { ChevronRight } from 'react-bootstrap-icons';
import ImageComponent from '../../utils/imageComponent';
import {
	InstantSearch,
	SearchBox,
	Pagination,
	ClearRefinements,
	RefinementList,
	Configure,
	useHits,
} from 'react-instantsearch';
import qs from 'qs';
import { useLocation } from '@reach/router';
import LinkComponent from '../../utils/linkComponent';

const EventsStyled = styled.div`
	margin-bottom: 2rem;
	margin-top: 2rem;

	.ais-Pagination {
		color: #3a4570;
		margin-top: 1em;
	}
	.ais-Pagination-list {
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		display: flex;
		align-items: center;
		margin: 0;
		padding: 0;
		list-style: none;
	}
	.ais-Pagination-item {
		margin-left: 0.3rem;
	}
	.ais-Pagination-link {
		padding: 0.3rem 0.6rem;
		display: block;
		border: 1px solid #c4c8d8;
		border-radius: 5px;
		-webkit-transition: background-color 0.2s ease-out;
		transition: background-color 0.2s ease-out;
		color: var(--primary);
	}
	.ais-Pagination-item--selected .ais-Pagination-link {
		color: #fff;
		background-color: var(--primary);
		border-color: var(--primary);
	}

	.ais-Pagination-item--disabled .ais-Pagination-link:hover {
		color: #a5abc4;
		background-color: #fff;
	}
	.ais-Pagination-item--disabled .ais-Pagination-link {
		opacity: 0.6;
		cursor: not-allowed;
		color: #a5abc4;
	}
	.ais-RefinementList {
		margin-bottom: 1em;
	}

	.ais-RefinementList-checkbox {
		height: 16px;
		margin-right: 16px;
	}

	.ais-RefinementList .ais-RefinementList-item .ais-RefinementList-label {
		align-items: center;
		display: flex;
	}
	.ais-RefinementList-count {
		align-items: center;
		background: #f5f5fa;
		border: 1px solid #d6d6e7;
		border-radius: 93px;
		box-sizing: border-box;
		color: #5a5e9a;
		display: flex;
		flex-direction: row;
		font-size: 12px;
		height: 16px;
		line-height: 16px;
		margin-left: auto;
		padding: 0 8px;
	}

	.ais-SearchBox {
		padding: 0.3em;
	}
	.ais-SearchBox-form {
		display: flex;
		height: 100%;
		position: relative;
		width: 100%;
	}
	.ais-SearchBox-input {
		background-color: #fff;
		border: 1px solid #d6d6e7;
		border-radius: 3px;
		box-shadow: inset 0 1px 4px 0 #7175b54d;
		color: #23263b;
		flex: 1;
		font-size: 14px;
		line-height: 20px;
		outline: none;
		padding: 14px 40px;
	}
	.ais-SearchBox-submit {
		left: 0.75rem;
		display: none;
	}

	.ais-SearchBox-reset {
		display: none;
	}

	.ZoneHeader {
		align-items: center;
		border-bottom: 1px solid #f5f5fa;
		display: flex;
		height: 60px;
		margin-bottom: 1em;
		padding-bottom: 1em;
		justify-content: space-between;
		align-items: baseline;
	}

	.ais-ClearRefinements-button:hover {
		background: #f5f5fa;
		cursor: pointer;
	}
	.ais-ClearRefinements-button {
		align-items: center;
		background: transparent;
		border: none;
		border-radius: 3px;
		color: #5a5e9a;
		cursor: pointer;
		display: flex;
		font-size: 0.875rem;
		font-weight: 400;
		justify-content: center;
		line-height: 1.25rem;
		padding: 2px 10px 2px 16px;
		position: relative;
		white-space: nowrap;
	}

	.ais-ClearRefinements-button--disabled {
		display: none;
	}
	button:disabled {
		display: none;
	}

	.ais-RefinementList-showMore:hover {
		background-image: linear-gradient(-180deg, #fff, #f5f5fa);
		border-color: #d6d6e7;
		cursor: pointer;
	}
	.ais-RefinementList-showMore {
		background: linear-gradient(180deg, #fff, #fcfcfd 97.81%);
		border: 1px solid #d4d4e9;
		border-radius: 3px;
		box-shadow: 0 1px 0 rgb(33 36 61 / 5%);
		box-sizing: border-box;
		color: #23263b;
		font-size: 14px;
		height: 32px;
		width: 100%;
		:active {
			border-color: #d6d6e7;
			box-shadow: inset 0 1px 4px 0 rgb(119 122 175 / 40%),
				inset 0 1px 1px 0 rgb(119 122 175 / 40%), 0 1px 0 0 rgb(35 38 59 / 5%);
		}
	}
	.ais-RefinementList-showMore--disabled {
		display: none;
	}

	.filterTitle {
		color: var(--primary);
		font-size: 0.85em;
		font-weight: 600;
		line-height: 20px;
		text-transform: uppercase;
	}
	.eventImage {
		width: 100%;
		aspect-ratio: 4/2.5;
		object-fit: cover;
		/* Caudit Beige */
		background-color: var(--secondary_3);
		border: 1px solid #ccc;
		margin-top: -2em;
	}

	.eventName {
		font-weight: 600 !important;
		/* color: #4d4d4d; 70% black */
		color: var(--secondary_1);
		font-size: 1.2em;
		margin-top: 1em;
		margin-bottom: 1em;
	}

	a {
		font-weight: 500;
	}

	.eventLocationCAUDIT {
		/* Caudit Beige */
		background-color: var(--primary);
		color: var(--secondary_6);
		margin-top: 1em;
		padding: 0.1em;
		font-size: 0.7em;
		font-size: var(--font-size-sm);
		width: fit-content;
		padding: 0em 1.5em;
		display: inline-block;
		text-align: center;
		border-radius: 30px;
	}
	.eventLocationAHECS {
		/* Caudit Beige */
		background-color: #003057;
		color: var(--secondary_6);
		margin-top: 1em;
		padding: 0.1em;
		font-size: 0.7em;
		font-size: var(--font-size-sm);
		width: fit-content;
		padding: 0em 1.5em;
		display: inline-block;
		text-align: center;
		border-radius: 30px;
	}
	.eventLocationTHETA {
		/* Caudit Beige */
		background-color: #187132;
		color: var(--secondary_6);
		margin-top: 1em;
		padding: 0.1em;
		font-size: 0.7em;
		font-size: var(--font-size-sm);
		width: fit-content;
		padding: 0em 1.5em;
		display: inline-block;
		text-align: center;
		border-radius: 30px;
	}
	.eventLocationExternal {
		/* Caudit Beige */
		background-color: var(--secondary_3);
		margin-top: 1em;
		padding: 0.1em;
		font-size: 0.7em;
		font-size: var(--font-size-sm);
		width: fit-content;
		padding: 0em 1.5em;
		display: inline-block;
		text-align: center;
		border-radius: 30px;
	}
	.externalPill {
		/* Caudit Beige */
		background-color: var(--secondary_3);
		margin-top: 1em;
		padding: 0.1em;
		margin-left: 1em;
		font-size: 0.7em;
		font-size: var(--font-size-sm);
		width: fit-content;
		padding: 0em 1.5em;
		display: inline-block;
		text-align: center;
		border-radius: 30px;
	}

	.eventDateCAUDIT {
		background-color: var(--primary);
		color: var(--secondary_6);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 6.6em;
		height: 4em;
		padding: 0.5em;
		position: relative;
		right: -0.8em;
		top: 1.3em;
		float: right;
		text-align: center;
		line-height: 1.3em;
		text-transform: uppercase;
		/*font-size: 0.8em;*/
		font-size: var(--font-size-sm);
		z-index: 3;
	}
	.eventDateAHECS {
		background-color: #003057;
		color: var(--secondary_6);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 6.6em;
		height: 4em;
		padding: 0.5em;
		position: relative;
		right: -0.8em;
		top: 1.3em;
		float: right;
		text-align: center;
		line-height: 1.3em;
		text-transform: uppercase;
		/*font-size: 0.8em;*/
		font-size: var(--font-size-sm);
		z-index: 3;
	}
	.eventDateTHETA {
		background-color: #187132;
		color: var(--secondary_6);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 6.6em;
		height: 4em;
		padding: 0.5em;
		position: relative;
		right: -0.8em;
		top: 1.3em;
		float: right;
		text-align: center;
		line-height: 1.3em;
		text-transform: uppercase;
		/*font-size: 0.8em;*/
		font-size: var(--font-size-sm);
		z-index: 3;
	}
	.eventDateExternal {
		background-color: var(--secondary_3);
		color: var(--secondary_1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 6.6em;
		height: 4em;
		padding: 0.5em;
		position: relative;
		right: -0.8em;
		top: 1.3em;
		float: right;
		text-align: center;
		line-height: 1.3em;
		text-transform: uppercase;
		/*font-size: 0.8em;*/
		font-size: var(--font-size-sm);
		z-index: 3;
	}

	.eventCard {
		padding: 1em;
		position: relative;
	}

	ul {
		list-style-type: none;
		padding-left: 0em;
	}

	h2 {
		font-size: 2.5rem;
	}

	.eventCategoryTitle {
		text-align: center;
	}

	@media (max-width: 768px) {
		.bannerCol {
			padding: 0 1em 0 1em !important;
		}
	}

	/* Ipad and Ipad Pro */
	@media screen and (min-device-width: 481px) and (max-width: 1024px) {
		.eventImage {
			width: 100%;
			/* height: 10em; */
		}
	}
`;

// const createURL = (state) => `?${qs.stringify(state)}`;
const createURL = (state) => {
	// console.log('state');
	// console.log(state);
	const isDefaultRoute =
		!state.query &&
		state.query === '' &&
		state.page === 1 &&
		state.refinementList &&
		state.refinementList?.[`event_type.title`]?.length === 0 &&
		state.refinementList?.[`topics.name`]?.length === 0 &&
		state.refinementList?.[`event_host`]?.length === 0;

	if (isDefaultRoute) {
		// console.log('it is default');
		return '/events/';
	}

	// const categoryPath = state.menu.resourceType
	// 	? `${getResourceTypeSlug(state.menu.resourceType)}/`
	// 	: '';
	const queryParameters = {};

	if (state.query) {
		queryParameters.query = encodeURIComponent(state.query);
	}
	if (state.page !== 1) {
		queryParameters.page = state.page;
	}
	if (state.refinementList?.[`event_type.title`]) {
		queryParameters.eventTypes =
			state.refinementList[`event_type.title`].map(encodeURIComponent);
	}
	// console.log('------');
	// console.log(state.refinementList?.[`topics.name`]);
	// console.log('------');
	if (state.refinementList?.[`topics.name`]) {
		queryParameters.topics =
			state.refinementList[`topics.name`].map(encodeURIComponent);
	}
	if (state.refinementList?.[`event_host`]) {
		queryParameters.host =
			state.refinementList[`event_host`].map(encodeURIComponent);
	}

	// console.log('queryParams');
	// console.log(queryParameters);
	const queryString = qs.stringify(queryParameters, {
		addQueryPrefix: true,
		arrayFormat: 'repeat',
	});
	// console.log('query String');
	// console.log(queryString);
	// console.log(`/resources/${queryString}`);

	return `/events/${queryString}`;
};

const searchStateToUrl = (searchState) =>
	searchState ? createURL(searchState.Events) : '';

// const urlToSearchState = ({ search }) => qs.parse(search.slice(1));

const urlToSearchState = (location) => {
	const {
		query = '',
		page = 1,
		eventTypes = [],
		topics = [],
		host = [],
	} = qs.parse(location.search.slice(1));
	// `qs` does not return an array when there's a single value.
	const allEventTypes = Array.isArray(eventTypes)
		? eventTypes
		: [eventTypes].filter(Boolean);
	const allTopics = Array.isArray(topics) ? topics : [topics].filter(Boolean);
	const allHosts = Array.isArray(host) ? host : [host].filter(Boolean);

	return {
		Events: {
			query: decodeURIComponent(query),
			page,
			// menu: {
			// 	resourceType: decodeURIComponent(resourceType),
			// },
			refinementList: {
				[`event_type.title`]: allEventTypes.map(decodeURIComponent),
				[`topics.name`]: allTopics.map(decodeURIComponent),
				[`event_host`]: allHosts.map(decodeURIComponent),
			},
		},
	};
};

function categoriseEvents(events) {
	var pastEvents = events.filter(
		(event) => new Date(event.end_date) < new Date()
	);
	var futureEvents = events.filter(
		(event) =>
			new Date(event.start_date) >= new Date() ||
			new Date(event.end_date) >= new Date()
	);
	return { futureEvents, pastEvents };
}

export default function EventCard(props) {
	const { searchClient } = props;
	const location = useLocation();
	const [searchState, setSearchState] = useState(
		// {}
		urlToSearchState(location)
	);
	const debouncedSetStateRef = useRef(null);

	const onSearchStateChange = (updatedSearchState, setUiState) => {
		// console.log(
		// 	'```````````````````----------------Started-----------------------'
		// );
		// console.log(updatedSearchState);
		clearTimeout(debouncedSetStateRef.current);
		debouncedSetStateRef.current = setTimeout(() => {
			// window.history.push(
			// 	searchStateToUrl(window.location, updatedSearchState)
			// );
			// console.log(searchStateToUrl(window.location, updatedSearchState));
			// console.log(searchStateToUrl(updatedSearchState));
			window.history.replaceState(
				null,
				null,
				searchStateToUrl(updatedSearchState)
			);

			// navigate(searchStateToUrl(window.location, updatedSearchState));
		}, 500);
		setSearchState(updatedSearchState);
		setUiState(updatedSearchState);
	};

	// useEffect(() => {
	// 	setSearchState(urlToSearchState(window.location));
	// }, [window.location]);

	return (
		<EventsStyled>
			<Container>
				<InstantSearch
					initialUiState={searchState}
					onStateChange={({ uiState, setUiState }) =>
						onSearchStateChange(uiState, setUiState)
					}
					createURL={createURL}
					indexName='Events'
					searchClient={searchClient}
				>
					<Row>
						<Col xs={12} md={6} lg={2} className='bannerCol'>
							<div className='left-panel'>
								<div className='ZoneHeader'>
									<span
										style={{
											color: '#23263b',
											fontSize: '16px',
											fontWeight: '500',
										}}
									>
										Filter
									</span>
									<ClearRefinements />
								</div>
								<h6 className='filterTitle'>Event Type</h6>
								<RefinementList
									operator='and'
									showMore
									attribute='event_type.title'
									showMoreLimit={100}
								/>
								<h6 className='filterTitle'>Topics</h6>
								<RefinementList
									operator='and'
									showMore
									attribute='topics.name'
									showMoreLimit={100}
								/>
								<h6 className='filterTitle'>Hosted By</h6>
								<RefinementList
									operator='and'
									showMore
									attribute='event_host'
								/>

								<Configure hitsPerPage={150} />
							</div>
						</Col>
						<Col
							xs={12}
							md={6}
							lg={10}
							style={{ paddingLeft: '1em' }}
							className='bannerCol'
						>
							<div className='right-panel'>
								<SearchBox />
								<Row className='justify-content-md-center'>
									<CustomHits />
								</Row>
								<Pagination />
							</div>
						</Col>
					</Row>
				</InstantSearch>
			</Container>
		</EventsStyled>
	);
}

const CustomHits = (props) => {
	const { hits } = useHits(props);
	var { futureEvents, pastEvents } = categoriseEvents(hits);
	const eventCardComponent = (hit) => (
		<Col sm={12} md={6} lg={4} className='eventCard' key={hit.id}>
			{hit.header_image !== null ? (
				<div>
					<LinkComponent
						to={hit.external_website_URL ? hit.external_website_URL : hit.slug}
						// target={hit.external_website_URL ? '_blank' : '_self'}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								page_name: 'Event Listing',
								title: hit.name,
								link_name: hit.external_website_URL
									? 'View Event Website'
									: 'View Event',
								link: hit.external_website_URL
									? hit.external_website_URL
									: hit.slug,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Event',
								url: window.location.href,
							});
						}}
					>
						<div
							className={
								hit.event_host === 'AHECS'
									? 'eventDateAHECS'
									: hit.event_host === 'CAUDIT'
									? 'eventDateCAUDIT'
									: hit.event_host === 'THETA'
									? 'eventDateTHETA'
									: 'eventDateExternal'
							}
						>
							{moment(hit.start_date).format('DD MMM YY') ===
							moment(hit.end_date).format('DD MMM YY')
								? moment(hit.start_date).format('DD MMM YY')
								: hit.start_date
								? hit.end_date
									? `${moment(hit.start_date).format('DD MMM YY')} - ${moment(
											hit.end_date
									  ).format('DD MMM YY')}`
									: moment(hit.start_date).format('DD MMM YY')
								: 'NA'}
						</div>
						{hit.header_image !== null ? (
							<div>
								<ImageComponent
									imageItem={hit.header_image}
									className='eventImage'
								></ImageComponent>
							</div>
						) : (
							''
						)}
					</LinkComponent>
				</div>
			) : (
				''
			)}
			{/* <div className='eventLocation'>{hit.location ? hit.location : null}</div> */}
			<div
				className={
					hit.event_host === 'AHECS'
						? 'eventLocationAHECS'
						: hit.event_host === 'CAUDIT'
						? 'eventLocationCAUDIT'
						: hit.event_host === 'THETA'
						? 'eventLocationTHETA'
						: 'eventLocationExternal'
				}
			>
				{hit.location ? hit.location : null}
			</div>
			<div className='externalPill'>
				{hit.event_host === 'External' ? 'External' : null}
			</div>

			<h3 className='eventName'>{hit.name}</h3>
			<div style={{ marginBottom: '1em' }}>
				<p>{hit.short_description?.substring(0, 150)}</p>
			</div>

			<div style={{ bottom: '0', position: 'absolute' }}>
				<LinkComponent
					// target={hit.external_website_URL ? '_blank' : '_self'}
					onClick={() => {
						window.analytics.track('Link Clicked', {
							page_name: 'Event Listing',
							title: hit.name,
							link_name: hit.external_website_URL
								? 'View Event Website'
								: 'View Event',
							link: hit.external_website_URL
								? hit.external_website_URL
								: hit.slug,
							path: window.location.pathname,
							report_type: 'New',
							collection_type: 'Event',
							url: window.location.href,
						});
					}}
					to={hit.external_website_URL ? hit.external_website_URL : hit.slug}
				>
					{/* View Event <ChevronRight color='black' size={18} /> */}
					{hit.external_website_URL ? 'View Event Website' : 'View Event'}
					<ChevronRight color='var(--link_color)' size={18} />
				</LinkComponent>
			</div>
		</Col>
	);
	return (
		<>
			{futureEvents.length > 0 ? (
				<>
					<h3 className='eventCategoryTitle mt-4 pt-2'>Upcoming Events</h3>
					{futureEvents.reverse().map((hit) => eventCardComponent(hit))}
				</>
			) : (
				''
			)}
			{pastEvents.length > 0 ? (
				<>
					<h3 className='eventCategoryTitle pt-5 m-2'>Past Events</h3>
					{pastEvents.map((hit) => eventCardComponent(hit))}
				</>
			) : (
				''
			)}
		</>
	);
};
